import React, { Suspense } from "react";
import TopNavBar from "./TopNavBar";
import Footer from "./Footer";
import SideNavBarAdmin from "./SideNavBarAdmin";
import "../../styles/App.css";

const Main = ({ children }) => {
  return (
    <div className="main-layout">
      <Suspense>
        <SideNavBarAdmin />
      </Suspense>

      <div className="main-content-wrapper">
        <Suspense>
          <TopNavBar />
        </Suspense>

        <section className="content-section">
          {children}
        </section>

        <Suspense>
          <Footer />
        </Suspense>
      </div>
    </div>
  );
};

export default Main;
